import Col from 'antd/lib/col';
import Row from 'antd/lib/row';
import Tooltip from 'antd/lib/tooltip';
import classNames from 'classnames';
import moment from 'moment';
import * as React from 'react';
import withStyles from 'react-jss';
import { StylesProps } from 'src/Library/Types';
import { numberFormatted } from 'src/utils/utils';
import { QuoteType } from '../../SE.interfaces';
import { SEQuoteCardStyles } from './SEQuoteCard.styles';

const styles = (theme) => ({
  ...SEQuoteCardStyles(theme),
});

interface IProps extends StylesProps<ReturnType<typeof styles>> {
  quote: QuoteType;
  deviationFromL1: string;
}

const formatAmount = (amount: number): string =>
  numberFormatted(amount, { places: 2, thousandSeparated: true });

const SEQuoteCard = (props: IProps): React.ReactElement => {
  const { classes, quote, deviationFromL1 } = props;
  const ranking = quote?.executionRanking;

  const renderIdentity = (): React.ReactElement => (
    <Col span={7} className={classes.cardBodyColumn}>
      <Tooltip title={quote?.bidderOrganisationName || ''}>
        <span className={classes.orgName}>{quote?.bidderOrganisationName || '-'}</span>
      </Tooltip>
      <span className={classes.label}>
        {quote?.isReferenceOnly ? 'Non-Spot L1 (reference)' : 'Vendor'}
      </span>
    </Col>
  );

  const renderValidity = (): React.ReactElement => (
    <>
      <Col span={5} className={classNames(classes.cardBodyColumn, classes.columnBorderLeft)}>
        <span className={classes.value}>
          {quote?.validityStartDate && moment(quote.validityStartDate).format('DD MMM YYYY')}
        </span>
        <span className={classes.label}>Starting Date</span>
      </Col>
      <Col span={5} className={classes.cardBodyColumn}>
        <span className={classes.value}>
          {quote?.validityEndDate && moment(quote.validityEndDate).format('DD MMM YYYY')}
        </span>
        <span className={classes.label}>End Date</span>
      </Col>
    </>
  );

  const renderRates = (): React.ReactElement => (
    <Col span={7} className={classNames(classes.cardBodyColumn, classes.columnBorderLeft)}>
      <span className={classes.boldPrice}>
        {ranking?.currency} {formatAmount(ranking?.amount)}
      </span>
      <span className={classes.label}>{ranking?.name}</span>
      {quote?.rank !== 1 && deviationFromL1 && (
        <span className={classes.deviation}>
          <b>Deviation from L1</b> {ranking?.currency} {formatAmount(Number(deviationFromL1))}
        </span>
      )}
    </Col>
  );

  const renderBottom = (): React.ReactElement => (
    <Row className={classes.bottomDiv}>
      <Col span={12} className={classes.bottomContent}>
        Rank {quote?.rank}
      </Col>
      <Col span={12} className={classes.bottomContent}>
        {quote?.isReferenceOnly ? 'For reference only' : ''}
      </Col>
    </Row>
  );

  return (
    <div className={classNames(classes.cardDiv, quote?.isReferenceOnly && classes.referenceCard)}>
      <Row className={classes.cardBody}>
        {renderIdentity()}
        {renderValidity()}
        {renderRates()}
      </Row>
      {renderBottom()}
    </div>
  );
};

export default React.memo(withStyles(styles)(SEQuoteCard));
